import {
    CheckOutlined,
    ExportOutlined,
    InfoCircleOutlined,
    QuestionCircleOutlined,
} from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Collapse,
    ConfigProvider,
    Input,
    Modal,
    Popover,
    Space,
    Typography,
} from 'antd';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';
import Img1 from '../../../assets/wenxian-1.jpg';
import Img2 from '../../../assets/wenxian-2.jpg';
import { useDevice } from '../../../hooks/useDevice';
import SelectedLiteratureItem from '../LiteratureSearchModal/SelectedLiteratureItem';
import { summaryStore } from '../store';
import { Btns } from '../Step1/index';

// 毕业论文第三步
const GraduationThesisStep3 = ({ notiApi }) => {
    const { isMobile } = useDevice();
    const [modal, contextHolder] = Modal.useModal();

    return (
        <div className="rounded-b-xl bg-white pb-8">
            {contextHolder}
            <h4 className="my-[26px_0_20px] grid w-full grid-cols-3 items-center px-4 leading-[23px] text-[#1a1b4c] md:px-6">
                <div></div>
                <div className="flex justify-center">文献推荐</div>
                <div className="flex justify-end">
                    {summaryStore.customReference.customReferenceDocument.length > 0 ? (
                        <Btns wrap={isMobile} />
                    ) : null}
                </div>
            </h4>

            {/*文献选择区域*/}
            <div className={'mb-3 w-full px-4 md:px-6'}>
                <div
                    className={
                        'mt-3 flex w-full flex-col items-center rounded-lg border border-[#EEEEF1] p-4'
                    }
                >
                    <div className={'mb-3 flex items-center gap-1'}>
                        <InfoCircleOutlined
                            style={{
                                color: 'var(--ant-color-primary)',
                            }}
                        />
                        <span className={'text-xs text-primary'}>
                            参考文献建议 10 条以上，请选择与你全文相关文献，切勿乱选/乱传参考文献
                        </span>
                    </div>

                    {summaryStore.customReference.customReferenceDocument.length ? (
                        <div className={'flex w-full flex-col gap-3'}>
                            {summaryStore.customReference.customReferenceDocument.map((it) => {
                                return (
                                    <SelectedLiteratureItem
                                        key={it.id}
                                        item={it}
                                        onClose={() => {
                                            summaryStore.deletesCustomReferenceDocument(it.id);
                                        }}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <Btns />
                    )}
                </div>
            </div>
            <div className="mt-5 flex flex-col items-center justify-between px-4 text-center text-[14px] text-[rgba(0,0,0,0.5)] md:flex-row md:px-12">
                <div className="flex items-center">
                    <Input.Search
                        placeholder="输入长文主题进行搜索"
                        allowClear
                        style={{ width: 250 }}
                        value={summaryStore.qy.searchKeywords}
                        onChange={(e) => {
                            summaryStore.qy.searchKeywords = e.target.value;
                        }}
                        onSearch={(value) => {
                            if (value) {
                                summaryStore.fetchWenxianList({
                                    subject: value,
                                });
                            } else {
                                // 如果没有值，则使用默认参数调用接口
                                summaryStore.fetchWenxianList();
                            }
                        }}
                        loading={summaryStore.qy.nextLoading}
                        enterButton
                    />
                </div>
                <div className="mt-2 md:mt-0">
                    自定义输入文献时，请使用{'  '}
                    <Popover
                        placement="rightTop"
                        trigger={isMobile ? 'click' : 'hover'}
                        content={
                            <div className="w-[600px] max-w-[90vw]">
                                <img src={Img1} className="my-1 w-full" />
                                <img src={Img2} className="my-1 w-full" />
                            </div>
                        }
                        title="文献获取指引"
                    >
                        <b>
                            查新引文格式
                            <QuestionCircleOutlined className="ml-[2px] align-[-2px] text-primary" />
                        </b>
                    </Popover>
                </div>
            </div>

            <div className="px-4 md:px-6">
                {summaryStore.qy.wenxianList.slice(0, 10).map((wenxianTitle, idx) => {
                    // 获取所有系统文献的ID
                    const systemWenxianIds = summaryStore.qy.wenxianList
                        .filter((it) => it && it.id)
                        .map((it) => it.id);

                    // 获取当前选中的系统文献ID
                    const selectedSystemIds = summaryStore.qy.selectIdList.filter(
                        (id) => id !== 'custom' && systemWenxianIds.includes(id),
                    );

                    // 判断是否全选和部分选中
                    const checked =
                        systemWenxianIds.length > 0 &&
                        systemWenxianIds.every((id) => selectedSystemIds.includes(id));

                    const indeterminate = selectedSystemIds.length > 0 && !checked;

                    // 判断当前项是否选中
                    let isSel = false;
                    if (idx === 0) {
                        // 自定义文献
                        isSel = summaryStore.qy.selectIdList.includes('custom');
                    } else if (wenxianTitle && wenxianTitle.id) {
                        // 系统文献
                        isSel = summaryStore.qy.selectIdList.includes(wenxianTitle.id);
                    }

                    const isFocus = summaryStore.qy.focusAbstractIdx === idx;

                    return (
                        <>
                            {idx === 0 && (
                                <>
                                    <div className="flex justify-between p-5">
                                        <Checkbox
                                            indeterminate={indeterminate}
                                            onChange={(e) => {
                                                summaryStore.stepWenxianSelectAll(e.target.checked);
                                            }}
                                            checked={checked}
                                        >
                                            文献全选
                                        </Checkbox>
                                        <div></div>
                                        <div
                                            onClick={() => {
                                                console.log(
                                                    'summaryStore.qy.selectIdList',
                                                    summaryStore.qy.selectIdList,
                                                );
                                                console.log(
                                                    'summaryStore.customReference',
                                                    summaryStore.customReference,
                                                );
                                            }}
                                        >
                                            使用系统推荐文献
                                        </div>
                                    </div>
                                </>
                            )}
                            {idx !== 0 && (
                                <div
                                    key={idx}
                                    className={twMerge(
                                        'mb-2 flex items-center justify-start rounded border border-transparent bg-white p-[15px]',
                                        'hover:shadow-[0_1px_4px_rgba(68,90,116,0.25)]',
                                        isFocus && 'border-[rgba(0,145,255,0.66)]',
                                        isSel && 'border-primary bg-[#EBD8FF]',
                                    )}
                                >
                                    <div className="flex-1">
                                        <Input.TextArea
                                            bordered={false}
                                            value={wenxianTitle.references}
                                            maxLength={2000}
                                            autoSize={true}
                                            readOnly={summaryStore.qy.nextLoading}
                                            onChange={(e) =>
                                                summaryStore.stepWenxianChange(idx, e.target.value)
                                            }
                                        />
                                        <div className="mt-[3px] p-[0_0_0_11px] text-xs text-[#999] md:pr-4">
                                            <Typography.Paragraph
                                                ellipsis={{
                                                    rows: 2,
                                                    expandable: true,
                                                    symbol: '展开',
                                                }}
                                                style={{
                                                    margin: 0,
                                                    fontSize: '12px',
                                                    color: '#999',
                                                }}
                                                className="[&_.ant-typography-expand]:text-primary"
                                            >
                                                {wenxianTitle.abstractContent}
                                            </Typography.Paragraph>
                                        </div>
                                    </div>

                                    {isSel ? (
                                        <CheckOutlined
                                            className="px-[30px] text-2xl text-primary"
                                            onClick={() => summaryStore.stepWenxianSelect(idx)}
                                        />
                                    ) : (
                                        <Button
                                            disabled={!wenxianTitle || summaryStore.qy.nextLoading}
                                            onClick={() => summaryStore.stepWenxianSelect(idx)}
                                        >
                                            <CheckOutlined />
                                            选择
                                        </Button>
                                    )}
                                </div>
                            )}
                        </>
                    );
                })}
                {/* 从第11条开始的数据使用Collapse包裹 */}
                {summaryStore.qy.wenxianList.length > 10 && (
                    <Collapse>
                        <Collapse.Panel header="展开更多文献" key="more">
                            {summaryStore.qy.wenxianList.slice(10).map((wenxianTitle, idx) => {
                                // 实际索引需要加上偏移量
                                const actualIdx = idx + 10;

                                // 判断当前项是否选中
                                let isSel = false;
                                if (wenxianTitle && wenxianTitle.id) {
                                    // 系统文献
                                    isSel = summaryStore.qy.selectIdList.includes(wenxianTitle.id);
                                }

                                const isFocus = summaryStore.qy.focusAbstractIdx === actualIdx;

                                return (
                                    <div
                                        key={idx}
                                        className={twMerge(
                                            'mb-2 flex items-center justify-start rounded border border-transparent bg-white p-[15px]',
                                            'hover:shadow-[0_1px_4px_rgba(68,90,116,0.25)]',
                                            isFocus && 'border-[rgba(0,145,255,0.66)]',
                                            isSel && 'border-primary bg-[#EBD8FF]',
                                        )}
                                    >
                                        <div className="flex-1">
                                            <Input.TextArea
                                                placeholder=""
                                                bordered={false}
                                                value={wenxianTitle.references}
                                                maxLength={2000}
                                                autoSize={true}
                                                readOnly={summaryStore.qy.nextLoading}
                                                onChange={(e) =>
                                                    summaryStore.stepWenxianChange(
                                                        actualIdx,
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                            <div className="mt-[3px] p-[0_0_0_11px] text-xs text-[#999] md:pr-4">
                                                <Typography.Paragraph
                                                    ellipsis={{
                                                        rows: 2,
                                                        expandable: true,
                                                        symbol: '展开',
                                                    }}
                                                    style={{
                                                        margin: 0,
                                                        fontSize: '12px',
                                                        color: '#999',
                                                    }}
                                                    className="[&_.ant-typography-expand]:text-primary"
                                                >
                                                    {wenxianTitle.abstractContent}
                                                </Typography.Paragraph>
                                            </div>
                                        </div>

                                        {isSel ? (
                                            <CheckOutlined
                                                className="px-[30px] text-2xl text-primary"
                                                onClick={() =>
                                                    summaryStore.stepWenxianSelect(actualIdx)
                                                }
                                            />
                                        ) : (
                                            <Button
                                                disabled={
                                                    !wenxianTitle || summaryStore.qy.nextLoading
                                                }
                                                onClick={() =>
                                                    summaryStore.stepWenxianSelect(actualIdx)
                                                }
                                            >
                                                <CheckOutlined />
                                                选择
                                            </Button>
                                        )}
                                    </div>
                                );
                            })}
                        </Collapse.Panel>
                    </Collapse>
                )}
            </div>
            <div className="flex h-[82px] items-center justify-center px-4 md:px-6">
                <Button
                    disabled={summaryStore.qy.nextLoading}
                    className="ml-4 h-[48px] w-[208px]"
                    onClick={() => summaryStore.setCurrentStep(1)}
                >
                    上一步
                </Button>
                <Button
                    className="ml-4 h-[48px] w-[208px]"
                    type="primary"
                    onClick={() => {
                        // 计算选中的文献总数
                        const customCount =
                            summaryStore.customReference.customReferenceDocument.length;
                        const systemSelectedCount = summaryStore.qy.selectIdList.filter(
                            (id) => id !== 'custom',
                        ).length;
                        const totalSelectedCount = customCount + systemSelectedCount;

                        // 检查是否超过30条
                        if (totalSelectedCount > 30) {
                            modal.warning({
                                title: '文献数量超限',
                                content: `您当前选择了 ${totalSelectedCount} 条文献，超过了30条的限制。请减少文献数量后再提交。`,
                            });
                            return;
                        }

                        // 获取所有选中的文献
                        const selectedSystemWenxian = summaryStore.qy.wenxianList.filter((it) =>
                            summaryStore.qy.selectIdList.includes(it.id),
                        );
                        const allSelectedReferences = [
                            ...summaryStore.customReference.customReferenceDocument,
                            ...selectedSystemWenxian,
                        ];

                        // 检查是否有英文文献
                        const hasEnglishLiterature = allSelectedReferences.some((ref) => {
                            const references = ref.references || '';
                            // 检查是否包含中文字符
                            const hasChinese = /[\u4e00-\u9fa5]/.test(references);
                            // 只有完全没有中文字符才认为是英文文献
                            return !hasChinese && references.trim().length > 0;
                        });

                        // 如果没有英文文献，弹出确认框
                        if (!hasEnglishLiterature && totalSelectedCount > 0) {
                            modal.confirm({
                                title: '提示',
                                content: '检测到没有英文文献，是否自动推荐英文文献？',
                                okText: '需要',
                                cancelText: '不需要',
                                onOk: () => {
                                    summaryStore.recommendEnglishLiterature = true;
                                    modal.confirm({
                                        title: '提示',
                                        content:
                                            '请确认您的大纲和参考文献无误。提交后，生成论文将无法修改大纲和参考文献',
                                        onOk: () => summaryStore.step3Submit(notiApi),
                                    });
                                },
                                onCancel: () => {
                                    summaryStore.recommendEnglishLiterature = false;
                                    modal.confirm({
                                        title: '提示',
                                        content:
                                            '请确认您的大纲和参考文献无误。提交后，生成论文将无法修改大纲和参考文献',
                                        onOk: () => summaryStore.step3Submit(notiApi),
                                    });
                                },
                            });
                            return;
                        }

                        // 如果有英文文献，直接进入下一步
                        summaryStore.recommendEnglishLiterature = false;
                        modal.confirm({
                            title: '提示',
                            content:
                                '请确认您的大纲和参考文献无误。提交后，生成论文将无法修改大纲和参考文献',
                            onOk: () => summaryStore.step3Submit(notiApi),
                        });
                    }}
                    loading={summaryStore.qy.nextLoading}
                >
                    下一步
                </Button>
            </div>
        </div>
    );
};

export default observer(GraduationThesisStep3);
